import PropTypes from 'prop-types'

const sujetImg = {
  id: PropTypes.number,
  title: PropTypes.string,
  alt: PropTypes.string,
  url: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}

const PropTypesUtils = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  sujet: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    thumbnail: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    contact: PropTypes.string,
    description: PropTypes.string,
    images: PropTypes.shape({
      day: PropTypes.shape(sujetImg),
      night: PropTypes.shape(sujetImg),
    }),
    productLink: PropTypes.string,
  }),
}

export default PropTypesUtils
